import { useCallback } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import PaginationRow from 'components/atoms/GefMui/PaginationRow';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import fetch from 'features/common/fetch';
import campaigns from 'features/views/campaignDashboards/campaigns';

import PlanedCampaignsTableRow from './PlanedCampaignsTableRow';

const fetchStorePath = `${fetch.constants.urls.campaignList}.${campaigns.constants.campaignViews.PLANED_CAMPAIGNS}`;

export const PlanedCampaignsTable = () => {
	const dispatch = useDispatch();
	const records = useSelector(campaigns.selectors.getPlanedCampaigns);

	const handleLoadMore = useCallback(() => {
		dispatch(campaigns.actions.planedCampaignsActions.loadMore());
	}, [dispatch]);

	const handlePaginationClick = useCallback(
		(e, page) => {
			dispatch(campaigns.actions.planedCampaignsActions.loadPage(page - 1));
		},
		[dispatch],
	);

	const handleReload = useCallback(() => {
		dispatch(campaigns.actions.planedCampaignsActions.reload());
	}, [dispatch]);

	const hasRecords = !isEmpty(records);

	return (
		<Stack spacing={2}>
			<ComponentLoader fetchStorePath={fetchStorePath} onReload={handleReload}>
				<Paper sx={{ p: 3, borderRadius: 2 }}>
					<SectionHeader text={getLabelMessage('campaigns:planedCampaignsTitle')} />
					<TableContainer>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell>{getLabelMessage('campaigns:name')}</TableCell>
									<TableCell>
										<div className="RightAlignColumn">
											{getLabelMessage('campaigns:dateFromStart')}
										</div>
									</TableCell>
									<TableCell width="200" />
									<TableCell width="70" />
									<TableCell width="70" />
								</TableRow>
							</TableHead>
							<TableBody className="Campaigns">
								{!hasRecords ? (
									<TableHasNoResults />
								) : (
									records.map((campaign) => <PlanedCampaignsTableRow campaign={campaign} />)
								)}
							</TableBody>
							<PaginationRow
								fetchStorePath={fetchStorePath}
								colSpan={100}
								onLoadNext={handleLoadMore}
								onPaginationClick={handlePaginationClick}
							/>
						</Table>
					</TableContainer>
				</Paper>
			</ComponentLoader>
		</Stack>
	);
};

export default PlanedCampaignsTable;
